import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/left.png'
import _imports_1 from '@/assets/images/right.png'
import _imports_2 from '@/assets/images/arrow-removebg-preview.png'


const _withScopeId = n => (_pushScopeId("data-v-2ccd7afc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trends" }
const _hoisted_2 = { class: "blogBg" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-2 order-2 order-md-1" }
const _hoisted_8 = { class: "blogSliderNav" }
const _hoisted_9 = { class: "blogSliderNavigation" }
const _hoisted_10 = { class: "sliderNavLeft" }
const _hoisted_11 = { class: "sliderNavRight" }
const _hoisted_12 = { class: "col-12 col-md-10 order-1 order-md-2" }
const _hoisted_13 = {
  key: 0,
  class: "blogList"
}
const _hoisted_14 = { class: "blogCard" }
const _hoisted_15 = { class: "img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_2,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_slide = _resolveComponent("slide")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.blogs.title")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("home.blogs.subTitle")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
                      src: _imports_0,
                      alt: ""
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
                      src: _imports_1,
                      alt: ""
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.blogs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_Carousel, {
                      ref: "myCarousel",
                      settings: _ctx.settings,
                      breakpoints: _ctx.breakpoints
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
                          return (_openBlock(), _createBlock(_component_slide, {
                            key: blog.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("img", {
                                    src: blog.src_url,
                                    alt: ""
                                  }, null, 8, _hoisted_16)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(new Date(blog.published_at))), 1),
                                _createElementVNode("p", {
                                  innerHTML: blog.short_description
                                }, null, 8, _hoisted_17),
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_router_link, {
                                    to: '/blog/' + blog.slug
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("buttons.readMore")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _hoisted_19
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["settings", "breakpoints"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}